var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResolvedticket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 0.75,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    fill: "#FCFCFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 0.75,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    stroke: "#00C851",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_24878)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1558 17.6935C13.6972 17.2332 13.0737 16.9753 12.4241 16.9753C11.7744 16.9753 11.1526 17.2332 10.6939 17.6935C9.73744 18.65 9.73744 20.199 10.6939 21.1555C12.3425 22.8056 14.8137 25.2768 16.4639 26.927C16.9225 27.3857 17.5461 27.6436 18.1957 27.6436C18.8453 27.6436 19.4672 27.3857 19.9258 26.927C22.588 24.2649 27.6528 19.2001 30.3133 16.5395C31.2698 15.583 31.2698 14.0324 30.3133 13.0759C29.8547 12.6173 29.2311 12.3594 28.5832 12.3594C27.9335 12.3594 27.3101 12.6173 26.8514 13.0759C24.4667 15.4606 20.2947 19.6326 18.7718 21.1555C18.6184 21.3089 18.4111 21.3938 18.1957 21.3938C17.9786 21.3938 17.7713 21.3089 17.6179 21.1555C16.8164 20.354 15.3327 18.8704 14.1558 17.6935Z",
    fill: "#00C851"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.106 12.4054C28.5794 12.4986 29.0186 12.7305 29.3647 13.0767C29.3648 13.0767 29.3649 13.0769 29.365 13.077C30.321 14.0331 30.3209 15.5832 29.3648 16.5393C26.704 19.2001 21.6383 24.2658 18.9773 26.9267C18.6312 27.2729 18.1921 27.5047 17.7188 27.5978C17.8734 27.6282 18.0316 27.6439 18.1914 27.6439C18.8407 27.6439 19.4635 27.3859 19.9226 26.9267C22.5836 24.2658 27.6493 19.2001 30.3101 16.5393C31.2662 15.5832 31.2663 14.0331 30.3104 13.077C30.3102 13.0769 30.3101 13.0767 30.3101 13.0767C29.8509 12.6174 29.2281 12.3594 28.5788 12.3594C28.4189 12.3594 28.2606 12.375 28.106 12.4054Z",
    fill: "#4CAF50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_24878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(9.5 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResolvedticket);
export default __webpack_public_path__ + "static/media/resolvedticket.e4da5f19e5985a15d05fa1ae970684ab.svg";
export { ForwardRef as ReactComponent };